const webPageMarkupSchema = (
  url: string,
  name: string,
  description: string
) => {
  const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;
  return {
    '@type': 'WebPage',
    url: `${SITE_URL}${url}`,
    name,
    description,
    isPartOf: {
      '@id': `${SITE_URL}/#website`,
    },
  };
};

export default webPageMarkupSchema;
